<template>
  <v-dialog persistent v-model="showDialog" scrollable max-width="800px">
    <v-card>
      <v-card-title>
        <strong>Create new POI</strong>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 600px;">
        <gmap-autocomplete
          class="box-input"
          :value="description"
          placeholder="Search to start"
          @place_changed="setPlace"
          :select-first-on-enter="false"
          :options="boundOptions"
        ></gmap-autocomplete>

        <v-layout class="map-layout">
          <v-flex class="pa-0" style="position: relative">
            <gmap-map
              :center="mapCenter"
              :zoom="16"
              ref="map"
              map-type-id="roadmap"
              @center_changed="updateCenter"
              @idle="syncMap"
              style="height:250px"
              class="map-container"
              :options="mapConfig"
            ></gmap-map>
          </v-flex>
        </v-layout>

        <v-divider class="my-3"></v-divider>
        <el-form :label-position="`left`" size="medium" label-width="120px" class="mt-3 pl-3">
          <el-form-item label="Google Place ID">
            <el-col :span="24">
              <el-input
                readonly
                v-model="form.poi_google_place_id"
                placeholder="Enter Google Place ID to start"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Place Name">
            <el-col :span="24">
              <el-input v-model="form.poi_name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Place Excerpt">
            <el-col :span="24">
              <el-input v-model="form.poi_excerpt"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Place Type">
            <el-col :span="24">{{typeList}}</el-col>
          </el-form-item>
          <el-form-item label="Coordinate">
            <el-col :span="12" class="pr-1">
              <el-input v-model="form.lat" readonly></el-input>
            </el-col>
            <el-col :span="12" class="pl-1">
              <el-input v-model="form.lng" readonly></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Place JSON">
            <el-col :span="24">
              <el-input readonly v-model="form.poi_detail_json" type="textarea" :rows="4"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <div id="map"></div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="showDialog = false">Close</v-btn>
        <v-btn color="red darken-2" flat @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../../services";
import { monthList } from "../../utils/Constants";

export default {
  name: "create-poi-dialog",
  props: {
    dialog: { default: false },
    shopId: { default: null }
  },
  data() {
    return {
      description: "",
      boundOptions: {
        types: ["geocode"]
      },
      form: {
        poi_status: "inactive",
        poi_google_place_id: "",
        poi_name: "",
        poi_excerpt: "",
        poi_detail_json: "",
        lat: "",
        lng: ""
      },
      typeList: [
        { value: "prayer", text: "ห้องละหมาด" },
        { value: "restaurant", text: "ร้านอาหาร" },
        { value: "hotel", text: "โรงแรม" },
        { value: "shop", text: "ร้านค้า" }
      ],
      reportedMapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  },
  mounted() {},
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {
    this.boundOptions = {
      componentRestrictions: { country: "th" },
      strictBounds: true,
      types: ["establishment"]
    };
  },
  mounted() {},
  methods: {
    setPlace(place, setLatLng = true) {
      if (!place) return;

      this.description = place.name;

      // Set center
      if (setLatLng) {
        this.mapCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
        this.reportedMapCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        };
      }

      // Find postal code
      place.address_components.find(address => {
        if (address.types[0] === "postal_code") {
          this.form.postal_code = address.long_name;
        }
      });

      this.form.poi_name = place.name;
      this.form.poi_excerpt = "";
      this.form.poi_google_place_id = place.place_id;
      this.form.poi_address = place.formatted_address;
      this.form.poi_detail_json = JSON.stringify(place);
      this.form.lat = this.mapCenter.lat;
      this.form.lng = this.mapCenter.lng;
    },
    updateCenter(latLng) {
      /*
      this.reportedMapCenter = {
        lat: latLng.lat(),
        lng: latLng.lng()
      };
      this.form.lat = latLng.lat();
      this.form.lng = latLng.lng();

      let geoCoder = new google.maps.Geocoder();

      geoCoder.geocode(
        { location: this.reportedMapCenter },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.setPlace(results[0], false);
            }
          }
        }
      );
      */
    },
    syncMap() {
      this.mapCenter = this.reportedMapCenter;
    },
    onSave() {
      Service.Cms.createPoi(this.form).then(res => {
        if (res.success) {
          this.form = {
            poi_status: "inactive",
            poi_google_place_id: "",
            poi_name: "",
            poi_excerpt: "",
            poi_detail_json: "",
            lat: "",
            lng: ""
          };
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.box-input {
  padding: 12px;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.24);
  background-color: rgba(0, 0, 0, 0.02) !important;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}
</style>